import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import IncidentTagsApi from '@/services/apiServiceModules/incidentsTagsApi.js'
const incidentTagsApi = new IncidentTagsApi()

export default class IncidentTagsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.INCIDENT_TAGS, incidentTagsApi, {
			useCache: true,
		})
	}
}
